import { render, staticRenderFns } from "./CalendeskWarningMessage.vue?vue&type=template&id=4a1036c6"
import script from "./CalendeskWarningMessage.vue?vue&type=script&lang=js"
export * from "./CalendeskWarningMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports